import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

const WinRateChart = ({ data, matchList = [], title = "Win Rate Trend" }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
        <div className="h-64 flex items-center justify-center text-gray-500">
          No trend data available
        </div>
      </div>
    )
  }

  // Create a lookup for match details
  const matchDetailsLookup = {}
  matchList.forEach(match => {
    matchDetailsLookup[match.match_number] = match
  })

  const chartData = data
    .filter(item => item.win_rate !== null)
    .map(item => {
      const matchDetails = matchDetailsLookup[item.match_number]
      return {
        match: item.match_number,
        winRate: parseFloat((item.win_rate * 100).toFixed(1)),
        opponent: matchDetails?.opponent || 'Unknown',
        date: matchDetails?.date || 'Unknown',
        sets: matchDetails?.sets || 'Unknown'
      }
    })

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="match" 
              axisLine={false}
              tickLine={true}
              tick={false}
            />
            <YAxis 
              domain={[0, 100]}
            />
            <Tooltip 
              formatter={(value, name, props) => [
                `${value}%`,
                'Win Rate'
              ]}
              labelFormatter={(label, payload) => {
                if (payload && payload[0] && payload[0].payload) {
                  const data = payload[0].payload
                  return `${data.opponent} - ${data.date} (${data.sets})`
                }
                return `Match ${label}`
              }}
            />
            <Line 
              type="monotone" 
              dataKey="winRate" 
              stroke="#3b82f6" 
              strokeWidth={2}
              dot={{ fill: '#3b82f6', r: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default WinRateChart